
import React from "react";
import { graphql, Link } from "gatsby";
import {Helmet} from "react-helmet";
import { Layout } from '../components';
import { StaticImage } from 'gatsby-plugin-image';
import   '../styles/home.scss';

const Index:React.FC = ({ data }:any)=>{
  return(
    <Layout>
       <Helmet>
          <meta charSet="utf-8" />
          <title>Mark It Done | Web &#038; Mobile Design and Development</title>
          <link rel="canonical" href="http://mysite.com/example" />
      </Helmet>
      <section className='header'>
        <div>
          <h2>Design</h2>
          <h3>Develop & Deploy</h3>
          <p>FrontEnd developer</p>
          <Link to="/projects" className='btn'>My Portfolio project</Link>
        </div>
        <StaticImage
          src="../images/banner.png"
          placeholder="blurred"
          layout="constrained"
          quality={100}
          formats={["auto", "webp", "avif"]}
          alt="A Gatsby astronaut"
        />
      </section>
    </Layout>
    
  );
};
export const query = graphql`
query MyQuery {
  file(relativePath: {eq: "banner.png"}) {
    id
    childrenImageSharp {
      fluid {
        ...GatsbyImageSharpFluid
      }
    }
  }
}
`

export default Index;